// extracted by mini-css-extract-plugin
module.exports = {"bookButton":"_1JA1Y","myBookingsScreen":"EoaGO"};